import { SubjectExam } from '../../plugins/api'
/* eslint-disable no-unused-vars */
export default {
  namespaced: true,
  actions: {
    async fetchSubjects({ commit }, options) {
      const subjects = await SubjectExam.fetch({ ...options })
      return subjects
    },
    async fetchSubject({ commit }, id) {
      const subject = await SubjectExam.fetchOne(id)
      return subject
    },
    async createSubject({ commit }, data) {
      const newSubject = await SubjectExam.create(data)
      return newSubject
    },
    async updateSubject({ commit }, { id, ...subjectData }) {
      const updatedSubject = await SubjectExam.update(id, { ...subjectData })
      return updatedSubject
    }
  }
}
/* eslint-disable no-unused-vars */
